import { gql } from 'graphql-tag';

const GET_UNIVERSITY_CAMPUS_LOCATIONS = gql`
	query getUniversityCampuses($universityUrl: String) {
		universityCampuses(university: $universityUrl) {
			locations {
				name
				description
				image
			}
			external_url
		}
	}
`;

export { GET_UNIVERSITY_CAMPUS_LOCATIONS };
